import { render } from "./ForgetPasswordView.vue?vue&type=template&id=7439c432"
import script from "./ForgetPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordView.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ForgetPasswordView.vue?vue&type=style&index=0&id=7439c432&lang=scss&module=true"
cssModules["$style"] = style0
import "./ForgetPasswordView.vue?vue&type=style&index=1&id=7439c432&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__